// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kwV2Unkj2ZLb1trZo-5eDg\\=\\={min-width:7.5rem}", "",{"version":3,"sources":["webpack://./pages/EmailReport/components/IntervalSelectComponent/styles.module.scss"],"names":[],"mappings":"AAAA,4BACE,gBAAA","sourcesContent":[".intervalSelect {\n  min-width: 7.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"intervalSelect": "kwV2Unkj2ZLb1trZo-5eDg=="
};
export default ___CSS_LOADER_EXPORT___;
